import axios from 'axios'
import config from '../config';

import { getQueryStringFromObject, getRequestHeaders } from './common.service';

const getWristbandReconditionnings = async (query) => {
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandReconditionning' + queryString, { headers: headers });
        } catch (error) {
            return error.response.data;
        }

        const regex = /^[a-zA-Z]+ (\d+)-(-?\d+)\/(\d+)$/;
        const header = response.headers['content-range'];
        const match = header.match(regex);
        let from, to, total;
        if (match) {
            [, from, to, total] = match;
        }
        if( total == '0') {
            from = 0;
            to = 0;
            total = 0;
        }
        return {elements: response.data, from: parseInt(from) + 1, to: parseInt(to) + 1, total: parseInt(total)};
    } catch (error) {
        return { error: error.message };
    }
};

export {
    getWristbandReconditionnings
}